import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7e3165bedae70014f27d40_1786748305465_2d557ece/neurominer/src/app/components/AuthScreen.tsx");
